import { useNavigate } from 'react-router-dom'
import {ArrowLeft, User, Building, CreditCard, Globe, Save} from 'lucide-react'
import { useState } from 'react'

export default function Configuracoes() {
  const navigate = useNavigate()
  
  const [dados, setDados] = useState({
    nomeEmpresa: 'Minha Empresa',
    nomeCompleto: 'João Silva',
    email: 'joao@email.com',
    pais: 'Brasil',
    profissao: 'Designer',
    chavePix: '',
    idioma: 'pt-BR'
  })

  const handleSave = () => {
    alert('Configurações salvas com sucesso!')
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-4">
            <button 
              onClick={() => navigate('/dashboard')}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ArrowLeft size={24} className="text-gray-600" />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-[#8B0000]">Configurações</h1>
              <p className="text-sm text-gray-600">Gerencie seus dados e preferências</p>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Dados Pessoais */}
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 mb-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center">
              <User size={24} className="text-[#8B0000]" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">Dados Pessoais</h2>
              <p className="text-sm text-gray-600">Informações da sua conta</p>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Nome Completo</label>
              <input
                type="text"
                value={dados.nomeCompleto}
                onChange={(e) => setDados({...dados, nomeCompleto: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B0000]"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">E-mail</label>
              <input
                type="email"
                value={dados.email}
                onChange={(e) => setDados({...dados, email: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B0000]"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">País</label>
                <input
                  type="text"
                  value={dados.pais}
                  onChange={(e) => setDados({...dados, pais: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B0000]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Profissão</label>
                <input
                  type="text"
                  value={dados.profissao}
                  onChange={(e) => setDados({...dados, profissao: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B0000]"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Dados da Empresa */}
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 mb-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center">
              <Building size={24} className="text-blue-600" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">Dados da Empresa</h2>
              <p className="text-sm text-gray-600">Informações do seu negócio</p>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Empresa / Marca</label>
            <input
              type="text"
              value={dados.nomeEmpresa}
              onChange={(e) => setDados({...dados, nomeEmpresa: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B0000]"
            />
          </div>
        </div>

        {/* Pagamentos */}
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 mb-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-green-50 rounded-lg flex items-center justify-center">
              <CreditCard size={24} className="text-green-600" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">Pagamentos</h2>
              <p className="text-sm text-gray-600">Configure como receber pagamentos</p>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Chave Pix</label>
            <input
              type="text"
              value={dados.chavePix}
              onChange={(e) => setDados({...dados, chavePix: e.target.value})}
              placeholder="E-mail, CPF, CNPJ ou telefone"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B0000]"
            />
          </div>
        </div>

        {/* Preferências */}
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 mb-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-purple-50 rounded-lg flex items-center justify-center">
              <Globe size={24} className="text-purple-600" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">Preferências</h2>
              <p className="text-sm text-gray-600">Idioma e personalização</p>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Idioma</label>
            <select
              value={dados.idioma}
              onChange={(e) => setDados({...dados, idioma: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B0000] appearance-none bg-white"
            >
              <option value="pt-BR">Português (Brasil)</option>
              <option value="en-US">English (US)</option>
              <option value="es-ES">Español</option>
            </select>
          </div>
        </div>

        {/* Botão Salvar */}
        <button
          onClick={handleSave}
          className="w-full bg-[#8B0000] text-white py-4 rounded-lg font-semibold hover:bg-[#6B0000] transition-colors flex items-center justify-center gap-2"
        >
          <Save size={20} />
          Salvar Alterações
        </button>
      </main>
    </div>
  )
}
